export default function SectionHeading({ eyebrow, title, copy, light = false, align = 'left' }) {
  return <div className={`${align === 'center' ? 'mx-auto text-center' : ''} max-w-2xl`}><p className={`eyebrow ${light ? 'text-cyan' : ''}`}>{eyebrow}</p><h2 className={`mt-4 font-display text-3xl font-extrabold leading-8 tracking-[-0.0005em] sm:text-4xl lg:text-[3.2rem] ${light ? 'text-white' : 'text-ink'}`}>{title}</h2>{copy && <p className={`mt-5 max-w-xl text-base leading-9 ${light ? 'text-slate-300' : 'text-slate'}`}>{copy}</p>}</div>;
}


